import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import Text from '~/shared/components/Text';
import { Button, desktop, mobile } from '~/techstyle-shared/react-components';

const Wrapper = styled.div`
  font-size: 14px;
  padding: 32px;
  background: ${({ theme }) => theme.colors.palette.white};
  border: 1px solid ${({ theme }) => theme.colors.accountBoxWrapper};
  border-radius: ${({ theme }) => theme.profileSectionBorderRadius};
  text-align: left;
  background-color: ${({ theme }) => theme.colors.palette.white};
  & + & {
    margin-top: 24px;

    ${mobile`
      margin-top: 0;
    `}
  }

  ${mobile`
    background: none;
    border: 0;
    padding: 24px;
  `}
`;

const Divider = styled.hr`
  border: none;
  height: 1px;
  margin: 24px 0;
  background-color: ${({ theme }) => theme.colors.accountBoxDivider};
`;

const Header = styled.div`
  display: flex;
`;

const HeadingContent = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: ${(props) => (props.centered ? 'center' : 'inherit')}};
`;

const Heading = styled(Text).attrs({
  forwardedAs: 'h2',
  variant: 'accountSectionHeader',
})`
  text-transform: uppercase;

  ${desktop`
    text-align: ${(props) => props.$textAlign};
  `}

  ${mobile`
     max-width: 250px;
  `}
`;

const HeadingDivider = styled(Divider)`
  margin-top: 8px;
  ${mobile`
    display: none;
  `}
`;

const Action = styled(Button).attrs({
  variant: 'unstyled',
})`
  font-size: 14px;
  font-weight: 600;
  text-align: right;
  color: ${({ theme }) => theme.colors.linkText};
  cursor: pointer;

  &:hover {
    cursor: pointer;
  }
`;

const ContentSection = styled.section`
  padding: 24px 0;
`;

const Content = styled.div`
  ${ContentSection} ~ ${ContentSection} {
    border-top: 1px solid ${({ theme }) => theme.colors.accountBoxContentBorder};
  }
  ${ContentSection}:last-child {
    padding-bottom: 0;
  }
  ${Divider}:last-child {
    display: none;
  }
`;

export default function AccountBox({
  actionText,
  children,
  centered,
  headingText,
  headingTooltip,
  ...rest
}) {
  let actionContent = null;
  if (actionText) {
    if (typeof actionText === 'string') {
      actionContent = <Action>{actionText}</Action>;
    } else {
      actionContent = actionText;
    }
  }

  return (
    <Wrapper {...rest}>
      {headingText && (
        <>
          <Header>
            <HeadingContent centered={centered}>
              <Heading centered={centered}>{headingText}</Heading>
              {headingTooltip}
            </HeadingContent>
            {actionContent}
          </Header>
          <HeadingDivider />
        </>
      )}
      <Content>{children}</Content>
    </Wrapper>
  );
}

AccountBox.Header = Header;
AccountBox.Heading = Heading;
AccountBox.Action = Action;
AccountBox.Divider = Divider;
AccountBox.HeadingDivider = HeadingDivider;
AccountBox.Content = Content;
AccountBox.ContentSection = ContentSection;

AccountBox.propTypes = {
  actionText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  centered: PropTypes.string,
  children: PropTypes.node,
  headingText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  headingTooltip: PropTypes.node,
};
